export default __webpack_public_path__ + "static/jvc-logo-b87a0ad6452925f575c9c3fdc4db7365.png";